import script from "./Sub1.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sub1.vue?vue&type=script&setup=true&lang=ts"

import "./Sub1.vue?vue&type=style&index=0&id=713a7182&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-713a7182"]])

export default __exports__